
import React from "react";

import { useState, useEffect } from "react";
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";
import { Chart } from "react-google-charts";
const API_PATH = "requests";

function List(match) {
  const { path } = match;
  const [chart, setChart] = useState(null);
  const [results2, setResults2] = useState(0);
  const [results, setResults] = useState(0);
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);

  const [agencies, setAgencies] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.getAll(API_PATH).then(x => {
      var requests = x.data;
      setChart(requests);

      var hash_map = new Map();
      for (var i in requests) {
        var request = requests[i];
        var agency = request.agency;
        var records_received = request.records_received;
        console.log(agency);
        console.log(records_received);
        var records = hash_map.get(agency) ? hash_map.get(agency) : 0;
        hash_map.set(agency, records_received == "Yes" ? records + 1 : records);
      }
      console.log(hash_map.size);
      console.log(hash_map.get("jhfkjasd"));

      var records = [];
      var agencies = [];
      records.push(["{chart.records_received}", "Deliquent"]);
      for (var [key, value] of hash_map.entries()) {
        console.log(key + " = " + value);
        var agency = new Object();
        agency.records = value;
        agency.name = key;
        agencies.push(agency);
        records.push([key, value]);
      }
      agencies.sort(function (a, b) {
        return b.records - a.records;
      });
      setAgencies(agencies);

      console.log("agencies: " + JSON.stringify(agencies));
      setData(records);
      console.table(records);

      setResults(requests.length);
    });
  }, []);

  const data2 = [
    ["{chart.records_received}", "Deliquent"], //agency and record received or not for columns here
    ["test", 6],
    ["test", 2],
    ["test", 2],
    ["test ", 2],
    ["test", 7],
  ];
  const options = {
    title: "Records Received",
    is3D: false,
  };
  return (
    <div style={{ textAlign: "center" }}>
      <Chart
        chartType="PieChart"
        data={data}
        options={options}
        width={"100%"}
        height={"1000px"}
        legendToggle='false'
      />

      <table className="table table-bordered">
        <thead>
          <tr>
            <th style={{ width: '30%' }}>Agency</th>
            <th style={{ width: '10%' }}>Records Received:</th>
          </tr>
        </thead>
        <tbody>
          {agencies && agencies.map(agency =>
            <tr key={agency.name}>
              <td>{agency.name}</td>
              <td>{agency.records}</td>
            </tr>
          )}
          {!agencies &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="spinner-border spinner-border-lg align-center"></div>
              </td>
            </tr>
          }
          {agencies && !agencies.length &&
            <tr>
              <td colSpan="4" className="text-center">
                <div className="p-2">No Users To Display</div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <br>
      </br>
      <br>
      </br>
      <br>
      </br>
    </div>

  );
};

export { List };
